import React, { useEffect, useState } from 'react'
import { SearchEngineContent } from 'scenes/Dashboard/scenes/SearchEngine/SearchEngineContent.component'
import { makeStyles } from 'tss-react/mui'
import { useMatchParams } from 'utils-next/routes'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Theme, Typography } from '@mui/material'

import { useSearchCandidatesStore } from '../SearchCandidatesList/SearchCandidatesList.component'
import { SearchFunction } from '../../../../../../../../entities-next/searchFunctions'
import { getApiScoutingCampaignHandlers } from '../../../../../../../../entities-next/scoutingCampaign'

export type SearchCandidateResultsProps = ExtendableStyles & Testable

export function SearchCandidateResults() {
  const { classes } = useStyles()

  const { scoutingCampaignId, searchCandidateId } = useMatchParams()
  const [scoutingCampaign, setScoutingCampaign] = useState<SearchFunction | null>(null)

  const { apiGetScoutingCampaign } = getApiScoutingCampaignHandlers()
  useEffect(() => {
    const retrieveData = async () => {
      const sc = await apiGetScoutingCampaign(Number(scoutingCampaignId))
      if (scoutingCampaign) {
        setScoutingCampaign(sc)
      }
    }
    retrieveData()
  }, [scoutingCampaignId, searchCandidateId])

  const { state: searchCandidatesStore } = useSearchCandidatesStore({ searchFunctionId: Number(scoutingCampaignId) })
  const searchCandidate = searchCandidatesStore.data
    ? searchCandidatesStore.data.find((searchCandidate) => searchCandidate.id === Number(searchCandidateId))
    : undefined

  return (
    <>
      <div>
        <Typography variant="body1" className={classes.challengeName}>
          {scoutingCampaign && scoutingCampaign.name}
        </Typography>
      </div>
      <SearchEngineContent
        initialFilters={{
          keywords: searchCandidate?.positivePrimaryKeywords || '',
          secondaryKeywords: searchCandidate?.positiveSecondaryKeywords,
          negativeKeywords: searchCandidate?.negativePrimaryKeywords,
          secondaryNegativeKeywords: searchCandidate?.negativeSecondaryKeywords,
          locations: searchCandidate?.locations,
          negativeLocations: searchCandidate?.negativeLocations,
          stages: searchCandidate?.stages,
          includeCompaniesWithoutMaturityInformation:
            searchCandidate?.includeCompaniesWithoutMaturityInformation ?? true,
          minimumYear: searchCandidate?.minimumYear,
          maximumYear: searchCandidate?.maximumYear,
        }}
        isFixedSearch
      />
    </>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  challengeName: {
    marginBottom: spacing(1),
  },
  tableContainer: {
    height: '70vh',
  },
}))
